/** Badge backgrounds for `litta.job_status.key` (white text on `.statusBadge`). */
const LITTA_JOB_STATUS_COLOURS: Record<string, string> = {
    ready_to_offer: '#F6D206',
    offered: '#CADEDB',
    offer_accepted: '#77AAA3',
    offer_rejected: '#FCA5A5',
    assigned: '#2E7068',
    acknowledged: '#003732',
    en_route: '#003732',
    arrived: '#003732',
    started: '#003732',
    before_photos_captured: '#003732',
    after_photos_captured: '#003732',
    signature_reviewed: '#003732',
    complete: '#03FF86',
    failed: '#EF4444',
    cancelled: '#000000',
}

const LITTA_JOB_STATUS_TEXT_COLOURS: Record<string, string> = {
    ready_to_offer: '#000000',
    offered: '#003732',
    offer_accepted: '#003732',
    offer_rejected: '#000000',
    assigned: '#F7F7F0',
    acknowledged: '#F7F7F0',
    en_route: '#F7F7F0',
    arrived: '#F7F7F0',
    started: '#F7F7F0',
    before_photos_captured: '#F7F7F0',
    after_photos_captured: '#F7F7F0',
    signature_reviewed: '#F7F7F0',
    complete: '#003732',
    failed: '#000000',
    cancelled: '#F7F7F0',
}

export function getLittaJobStatusTextColour(
    key: string | undefined,
): string | undefined {
    if (!key) return undefined
    return LITTA_JOB_STATUS_TEXT_COLOURS[key]
}

const UNKNOWN_KEY_FALLBACK = '#6b7280'
const warnedUnknownKeys = new Set<string>()

export function getLittaJobStatusColour(key: string | undefined): string {
    if (!key) {
        return UNKNOWN_KEY_FALLBACK
    }
    const colour = LITTA_JOB_STATUS_COLOURS[key]
    if (colour) {
        return colour
    }
    if (!warnedUnknownKeys.has(key)) {
        warnedUnknownKeys.add(key)
        console.warn(
            `No badge colour for litta job_status key "${key}" — using neutral fallback`,
        )
    }
    return UNKNOWN_KEY_FALLBACK
}
